.grid {
  grid-template-columns: repeat(2, 1fr);
}

.option {
  gap: 0;
  height: 112px;
}

@media (--reefer-media-tablet-max) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .option {
    gap: 0;
    height: 104px;
  }
}
